import { useEffect, useState } from "react";
import { STATIC_STRINGS } from "@asez/shared";
import RenderTable from "./renderTable";
import { Topic } from "../types";
import AddSkillsModal from "./AddSkillsModal";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../../store";
import { updateTotalQuestions } from "../../../../../store/steps/stepTwoSlice";

const calculateTotalQuestions = (topicsData: Topic[]): number => {
  return topicsData.reduce(
    (total, topic) =>
      total +
      topic.questionTypes.reduce(
        (subTotal, question) => subTotal + question.numberOfQuestions,
        0
      ),
    0
  );
};

const RenderGrid = () => {
  const dispatch = useDispatch();
  const [isSkillModalOpen, setSkillModalOpen] = useState<string>("");

  const { skillsDistribution, totalQuestions } = useSelector(
    (state: RootState) => state.stepTwo
  );

  useEffect(() => {
    if (skillsDistribution) {
      const calculatedTotal = calculateTotalQuestions(skillsDistribution);
      dispatch(updateTotalQuestions(calculatedTotal));
    }
  }, [skillsDistribution]);

  return (
    <>
      <div className="h-full flex flex-col text-sm xl:text-base">
        <div className="flex justify-between items-center pb-2 h-[10%]">
          <div className="flex">
            Total Questions :&nbsp;
            <div className="font-semibold mr-2">{totalQuestions}</div>
            {STATIC_STRINGS.ESTIMATED_ASSESSMENT_TIME}&nbsp;
            <div className="font-semibold">{totalQuestions * 10} Mins</div>
          </div>
          <button
            onClick={() => setSkillModalOpen("open")}
            className="btn btn-primary py-1 px-4 shadow-md"
          >
            {STATIC_STRINGS.ADD_SKILLS}
          </button>
        </div>
        <RenderTable topicsData={skillsDistribution} />
      </div>
      {isSkillModalOpen && (
        <AddSkillsModal
          isModalOpen={isSkillModalOpen}
          setModalOpen={setSkillModalOpen}
        />
      )}
    </>
  );
};

export default RenderGrid;
